import { render, staticRenderFns } from "./TitleOverlay.vue?vue&type=template&id=18052aa2&scoped=true&lang=html&"
import script from "./TitleOverlay.vue?vue&type=script&lang=js&"
export * from "./TitleOverlay.vue?vue&type=script&lang=js&"
import style0 from "./TitleOverlay.vue?vue&type=style&index=0&id=18052aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18052aa2",
  null
  
)

export default component.exports